import React from 'react';
import { Section } from 'src/components/Section';
import { Paragraph, SectionTitle } from 'src/components/Typography';
import { AnchorButton } from 'src/components/Button';
import { mediaQueries } from 'src/style/breakpoints';

const BootcampTypeSmall = ({ isFullTimePage }) => {
  return (
    <Section theme="ternary" css={{ alignItems: 'center' }}>
      <SectionTitle isCenter>
        {' '}
        Vous préférez le temps {isFullTimePage ? 'partiel' : 'plein'}&nbsp;?
      </SectionTitle>
      <Paragraph css={{ textAlign: 'center' }}>
        Nous proposons aussi cette formation sur une période de{' '}
        {isFullTimePage
          ? `6 mois, en cours du soir et
            week-end`
          : `10 semaines`}
      </Paragraph>
      <div css={{ display: 'flex', justifyContent: 'center' }}>
        <AnchorButton
          to={
            isFullTimePage
              ? '/bootcamp-javascript/formation-developpeur-web-mobile-temps-partiel/'
              : '/bootcamp-javascript/formation-developpeur-web-mobile/'
          }
        >
          Découvrir{' '}
          <br
            css={{
              [mediaQueries.tabletPortraitUp]: {
                display: 'none',
              },
            }}
          />{' '}
          la formation à temps {isFullTimePage ? 'partiel' : 'plein'}
        </AnchorButton>
      </div>
    </Section>
  );
};

export default BootcampTypeSmall;
